module.exports = __webpack_public_path__ + "static/media/20_tn.18613236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/20_tn.jpg
// module id = 450
// module chunks = 0